import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ClientContextService } from './client-context.service';

@Injectable({ providedIn: 'root' })
export class CdnPathService {
    private readonly cdnBaseUrl: string;
    private readonly cdnClientUrl: string;

    constructor(clientContextService: ClientContextService) {
        // Remove any trailing slashes from the configuration file (if any exist)
        const cdnHost: string = environment.cdnHost.replace(/\/+$/, '');
        const cdnEnvironment: string = clientContextService.cdnEnvironment;
        const cdnRootUrl: string = `${cdnHost}/clients/${environment.cdnProject}/${cdnEnvironment}`;

        // Set the different CDN pathways that will be used with this service
        this.cdnBaseUrl = `${cdnRootUrl}/${environment.cdnBaseClientCode}`;
        this.cdnClientUrl = `${cdnRootUrl}/${clientContextService.clientCode}`;
    }

    public readonly clientCss = (): string => `${this.cdnClientUrl}/client.css`;

    public readonly frameworkCss = (): string => `${this.cdnBaseUrl}/framework.css`;

    public readonly fontAwesomeCss = (): string => `${this.cdnBaseUrl}/v6fontawesome.css`;

    public readonly imageUrlBase = (fileName?: string): string =>
        fileName?.trim() ? `${this.cdnBaseUrl}/images/${fileName.trim()}` : '';

    public readonly imageUrlClient = (fileName?: string): string =>
        fileName?.trim() ? `${this.cdnClientUrl}/images/${fileName.trim()}` : '';
}
